import React from 'react';
import Lang from '@lang/en';
import { NullableNumber, NullableString } from '../types';
import { TableColumn, TableColumns, TableRow, TableRows } from './types';

interface EmptyTableProps {
  numberOfColumns: number;
}

interface Props {
  rows?: TableRows;
  columns?: TableColumns;
  onRowClick?: (id: NullableNumber | NullableString) => void;
  EmptyTableComponent?: React.FC<EmptyTableProps>;
}

const DefaultEmptyTable: React.FC<EmptyTableProps> = ({ numberOfColumns }) => (
  <tr>
    <td colSpan={numberOfColumns} id="empty" data-testid="no-result-found">
      {Lang.noRecordFoundText}
    </td>
  </tr>
);

const TBody: React.FC<Props> = ({
  rows = [],
  columns = [],
  EmptyTableComponent = DefaultEmptyTable,
  onRowClick,
  ...restProps
}) => {
  return (
    <tbody {...restProps}>
      {rows.length ? (
        rows.map((row: TableRow, index: number) => (
          <tr
            key={(row.id?.value as string) || `item-${index}`}
            className={`table-tr ${!!onRowClick && 'clickable'}`}
            onClick={() => onRowClick && onRowClick(row.id?.value as string)}
          >
            {columns.map(({ key: columnKey = '' }: TableColumn) => {
              if (!row[columnKey]) {
                return false;
              }

              const { value, ...rest } = row[columnKey];
              return (
                <td key={columnKey} {...rest}>
                  {value}
                </td>
              );
            })}
          </tr>
        ))
      ) : (
        <EmptyTableComponent numberOfColumns={columns.length} />
      )}
    </tbody>
  );
};

export default TBody;
